import { registerDocumentThumbnailRenderers } from '@wwf/sdk';
import { renderPdfFirstPageToCanvas } from '@core/utils/renderPdfFirstPageToCanvas';
import { renderDocxFirstPageToCanvas } from '@core/utils/renderDocxFirstPageToCanvas';

/**
 * Wires the backoffice's web-only document renderers (pdf.js / docx-preview)
 * into the SDK so resource uploads can compute document thumbnails. Imported
 * for its side effect at app startup.
 */
registerDocumentThumbnailRenderers({
    pdf: renderPdfFirstPageToCanvas,
    word: renderDocxFirstPageToCanvas,
});
